import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Button, CircularProgress, IconButton, Grid } from "@mui/material";
import Table from 'react-bootstrap/Table';
import axios from "axios";
import Cookies from "js-cookie";
import { API, SaveQuestionnaire, UpdateJobPost } from "../classes/config/controller";
import { formatDate, getOrCreateProfile } from "../classes/GlobalFunctions";

import { ReferenceSetupModal } from "../components/Modals/ReferenceSetupModal";
import { Spinner } from "react-bootstrap";
import ToolTipButton from "../components/ToolTipButton";
import { Delete, InfoOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { SearchBar } from "../components/SearchBar";
export const Archived = ()=>{
  const navigate = useNavigate();
const [user, setUser] = useState(Cookies.get('user'))
const [data, setData] = useState([])
const [loading, setLoading] = useState(true)
const [update, setUpdate] = useState(false)
const [show, setShow] = useState(false);
const [id, setId] = useState('false');
const [searchBar, setSearchBar] = useState('');

const handleClose = () => setShow(false);
const handleShow = () => setShow(true);


const deleteArchivedReference = async (referenceId) => {
  const conf = window.confirm('Are you sure you want to delete this archived reference? This action cannot be undone.');
  
  if (conf) {
    try {
      const response = await axios.post(`${API}rc/delete-archived-reference`, {
        id: id, // The profile ID
        referenceId: referenceId // The archived reference ID
      });

      console.log('Archived reference deleted:', response.data);
      setUpdate(!update); // Trigger re-fetch of data after deletion
    } catch (error) {
      console.error('Error deleting archived reference:', error);
      window.alert('An error occurred while deleting the archived reference. Please try again.');
    }
  }
};

useEffect(()=>{
    
    getOrCreateProfile(user)
    .then(profile => {
        console.log('Profile data:', profile);
        setId(profile._id);
        setData(profile)
        setLoading(false)
        // You can now use the profile data in your frontend application
    });

},[update])

if(loading){
  return( <Box sx={{textAlign:'center'}}><Spinner/></Box>  )
} else {
        
    return (
        <Box sx={{padding:1, margin:1}}>
               
     
      <Grid sx={{marginBottom:2}} container>
        <Grid xs={12} md={12} item>
         <SearchBar
         label="Search Applicant By Name"
         value={searchBar}
         onChange={(e)=> setSearchBar(e.target.value)}
         />
        </Grid>
     
      </Grid>
        
        <Paper sx={{padding:1}}>

             <Table hover>
      <thead>
        <tr>
        
          <th><Typography variant="button"><b>Applicants</b></Typography></th>
          <th><Typography variant="button"><b>Date Created</b></Typography></th>
          <th style={{textAlign:'center'}}><Typography variant="button"><b>Completion Status</b></Typography></th>
          <th style={{textAlign:'center'}}><Typography variant="button"><b>Actions</b></Typography></th>
        </tr>
      </thead>
      <tbody>
          {data.referenceChecker?.archivedReferences?.filter(i =>
          (i.applicant.firstName).toLowerCase().includes(searchBar.toLowerCase()) ||
          (i.applicant.lastName).toLowerCase().includes(searchBar.toLowerCase())
        ).map(i=>{
            return(
                <tr key={i.id}>
        
          <td style={{paddingTop:'15px'}}><span >{i.applicant.firstName + ' ' +i.applicant.lastName}</span> </td>
          <td style={{paddingTop:'15px'}}>{formatDate(i.dateCreated)}</td>
          <td style={{paddingTop:'15px',textAlign:'center'}}>{i.references.filter(i=> (i.status === 'complete')).length}/{i.references.length}</td>
          <td style={{textAlign:'center'}}>
            <ToolTipButton
            Title="Applicant's Reference Details"
            Icon={<InfoOutlined htmlColor="dodgerBlue"/>}
            onClick={() => navigate('/archived-reference-details', {
              state: { 
                id:id,
                referenceCheckId: i.id,        // Pass the reference check ID
              }
            })}          
            />
            <ToolTipButton
            Title="Delete"
            Icon={<Delete htmlColor="tomato"/>}
            onClick={() => deleteArchivedReference(i.id)}            
            />
           </td>
        </tr>
            )
          })}
      </tbody>
    </Table>
        </Paper>
        <ReferenceSetupModal id={id} worksheets={data.referenceChecker.worksheets} companies={data.referenceChecker.userCompanies} handleClose={handleClose} handleCloseAndSend={()=>{handleClose(); setUpdate()}} show={show}/>
        </Box>
    )
}
}